import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Payment } from '@payment/const';
import { PaymentActions, PaymentSelectors, StateWithPayment } from '@payment/data-access';
import { AuthService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { PaymentService } from './payment.service';

@Injectable()
export class PaymentLazyService implements PaymentService, OnDestroy {
  private subscription = new Subscription();

  constructor(
    private store: Store<StateWithPayment>,
    private authService: AuthService,
  ) {}

  init(): void {
    this.subscription.add(
      this.authService
        .isUserLoggedIn()
        .pipe(distinctUntilChanged())
        .subscribe((isUserLoggedIn: boolean) => {
          if (isUserLoggedIn) {
            this.store.dispatch(new PaymentActions.LoadPaymentList());
          } else {
            this.store.dispatch(new PaymentActions.ResetLoadPaymentList());
          }
        }),
    );
  }

  loadPaymentList(): void {
    this.store.dispatch(new PaymentActions.LoadPaymentList());
  }

  getPayments(): Observable<Payment[]> {
    return this.store.select(PaymentSelectors.getPaymentsValue);
  }

  getPaymentsLoading(): Observable<boolean> {
    return this.store.select(PaymentSelectors.getPaymentsLoading);
  }

  getPaymentsError(): Observable<boolean> {
    return this.store.select(PaymentSelectors.getPaymentsError);
  }

  deletePayment(payment: Payment): void {
    this.store.dispatch(new PaymentActions.DeletePayment(payment.bindingId));
  }

  getDeletePaymentLoading(): Observable<boolean> {
    return this.store.select(PaymentSelectors.getDeletePaymentLoading);
  }

  getDeletePaymentError(): Observable<boolean> {
    return this.store.select(PaymentSelectors.getDeletePaymentError);
  }

  resetDeletePayment(): void {
    this.store.dispatch(new PaymentActions.ResetDeletePayment());
  }

  setActivePayment(payment: Pick<Payment, 'bindingId'>): void {
    this.store.dispatch(new PaymentActions.BindPayment(payment.bindingId));
  }

  resetActivePayment(): void {
    this.store.dispatch(new PaymentActions.BindPayment(null));
  }

  getActivePayment(): Observable<Payment | null> {
    return this.store.select(PaymentSelectors.getBindPayment);
  }

  getBindPaymentLoading(): Observable<boolean> {
    return this.store.select(PaymentSelectors.getBindPaymentLoading);
  }

  getBindPaymentLater(): Observable<boolean> {
    return this.store.select(PaymentSelectors.getBindPaymentLater).pipe(filter((value) => value !== undefined));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
